import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { api } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { Disc3 } from 'lucide-react';

/**
 * Runs when the app URL contains #session_id=... (returning from Emergent OAuth).
 * Exchanges the session_id for an httpOnly cookie via /api/auth/session, then routes to /.
 * Uses useRef to prevent double-processing under React StrictMode.
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash || '';
    const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/', { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post(
          '/auth/session',
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser(data.user);
        // Strip the hash so we don't re-trigger
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/', { replace: true, state: { user: data.user } });
      } catch (e) {
        navigate('/', { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="text-center">
        <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#FFB800] to-[#FF007F] flex items-center justify-center mx-auto shadow-[0_0_30px_rgba(255,0,127,0.4)]">
          <Disc3 className="w-6 h-6 text-[#120505] vinyl-spin" />
        </div>
        <div className="mt-4 font-display text-xl text-[#FFF3E0]">Setting the stage…</div>
        <div className="mt-1 text-xs text-[#BFA5A5]">Ek pal rukiye</div>
      </div>
    </div>
  );
};

export default AuthCallback;
